import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogsApi = createApi({
  reducerPath: "blogsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API, // Should be: "http://192.168.2.11:1026/v1/"
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllBlogs: builder.query({
      query: ({ type, code ,query , page , search}) => {
        let queryParams = `type=${type}`;
        if (code) {
          queryParams += `&code=${code}`;
        }
        if(search){
            queryParams += `&search=${search}`;
        }
        if(page){
            queryParams += `&page=${page}`;
        }
        return {
          url : `blog?${queryParams}` ,
          method:"GET"
        };
      },
      // transformResponse: (response) => response.data,
    }),
  }),
});

export const { useGetAllBlogsQuery } = blogsApi;
